'use strict';

const GENERATE_CLOSEOUT_CONFIRM =
  'Close out this project? This creates a final package and marks the project closed out.';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function money(v) {
  const n = typeof v === 'number' ? v : parseFloat(v);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}

function shortDate(value) {
  const m = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return String(value || '');
  return `${MONTHS[Number(m[2]) - 1]} ${Number(m[3])}`;
}

function closeoutChecks({
  revised,
  billed,
  held,
  unpaidReleases,
  payApps,
  documents,
  handover,
} = {}) {
  const apps = Array.isArray(payApps) ? payApps : [];
  const docs = Array.isArray(documents) ? documents : [];
  const rev = money(revised);
  const bill = money(billed);
  const workBilled = rev > 0 && bill >= rev - 0.02;

  const nonRelease = apps.filter((pa) => !pa.is_retainage_release && !pa.deleted_at);
  const due = money(nonRelease.reduce((s, pa) => s + money(pa.amount_due), 0));
  const paid = money(nonRelease.reduce((s, pa) => s + money(pa.amount_paid), 0));
  const reconciled = due > 0 ? Math.abs(paid - due) <= 0.02 : bill > 0 && Math.abs(money(held) + money(unpaidReleases)) <= 0.02 && paid >= due - 0.02;

  const warranty = docs.some((d) => !d.deleted_at && String(d.doc_type || '').toLowerCase().includes('warranty'));

  const handoverAt = handover && (handover.accepted_at || handover.acceptedAt);
  const handoverBy = handover && (handover.accepted_by || handover.acceptedBy);
  const handoverOk = Boolean(handoverAt && handoverBy);

  const releases = apps.filter((pa) => pa.is_retainage_release && !pa.deleted_at);
  const releasesPaid = releases.every((pa) => {
    const st = String(pa.payment_status || pa.status || '');
    return st === 'paid' || st === 'payment_received' || money(pa.amount_paid) > 0;
  });
  const retainage = money(held) <= 0.02 && money(unpaidReleases) <= 0.02 && releasesPaid;

  const helpers = {
    work_billed: 'Bill remaining approved work on a pay application.',
    payments_reconciled: 'Record payments until collected matches billed.',
    warranty: 'Attach a warranty document to complete this check.',
    handover: 'Record the date and who accepted handover.',
    retainage: 'Collect remaining retainage.',
  };

  function row(id, label, status, extra = {}) {
    const out = { id, label, status, ...extra };
    if (status !== 'complete') out.helper = helpers[id];
    return out;
  }

  return [
    row('work_billed', 'All approved work billed', workBilled ? 'complete' : 'incomplete'),
    row('payments_reconciled', 'Payments reconciled', reconciled ? 'complete' : 'incomplete'),
    row('warranty', 'Warranty doc attached', warranty ? 'complete' : 'incomplete'),
    row('handover', 'Handover accepted', handoverOk ? 'complete' : 'not_recorded', {
      detail: handoverOk ? `Accepted by ${handoverBy} on ${shortDate(handoverAt)}` : 'not recorded',
    }),
    row('retainage', 'Retainage collected', retainage ? 'complete' : 'incomplete'),
  ];
}

export { closeoutChecks, GENERATE_CLOSEOUT_CONFIRM };
